<template>
  <div>
    <div class="limiter">
      <div class="image">
        <img src="../assets/logo/logo.png" alt="Logo">
      </div>
      <div class="container-login100">
        <div class="wrap-login100">
          <form class="login100-form validate-form" @submit.prevent="submitPin">
            <h1>
            <span class="login100-form-title">
              Enter otp from Customer
            </span>
            </h1>
            <div class="form-group">
              <label for="otp">OTP</label>
                <input id="otp" v-model="otp" class="input100" type="tel" name="otp" placeholder="Enter OTP" min="0" required>
            </div>
            <button type="submit" class="login100-form-btn">
              Submit
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      otp: '',
      id: this.$route.query.id
    };
  },
  watch: {
    '$route.query.id': function(newId) {
      this.id = newId;
    },
  },

  methods: {
    async submitPin() {
      this.$store.commit('setLoadingState', true);
      const payload = {
        dispatchId: this.id,
        otp: this.otp,
      }
      return await this.$store.dispatch('completed', payload)
        .then(() => {
          responses.showSuccess(`Your information has been submitted!`)
          this.logout();
        })
        .finally(()=> this.$store.commit('setLoadingState', false))
    },

    logout() {
      localStorage.removeItem('user');

      this.$router.push(`/login?id=${this.id}`);
    },
  }
};
</script>

<style scoped>
/* Add your styles here */
</style>
